"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var metadataKeys_1 = require("./metadataKeys");
function addKeys(namesKey) {
    return function (target, key) {
        var names = Reflect.getMetadata(namesKey, target);
        if (names) {
            names = names + '|' + key;
        }
        else {
            names = key;
        }
        Reflect.defineMetadata(namesKey, names, target);
    };
}
function effect() {
    return function (target, key, descriptor) {
        addKeys(metadataKeys_1.effectNamesKey)(target, key);
    };
}
exports.effect = effect;
function typeDef() {
    return function (target, key) {
        addKeys(metadataKeys_1.typeDefNamesKey)(target, key);
    };
}
exports.typeDef = typeDef;
function asyncTypeDef() {
    return function (target, key) {
        addKeys(metadataKeys_1.asyncTypeDefNamesKey)(target, key);
    };
}
exports.asyncTypeDef = asyncTypeDef;
//# sourceMappingURL=decorators.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@awaw00/rxstore/lib/decorators.js
// module id = 268
// module chunks = 0